module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_txt01_01_1-61715af361fad79a947daaa132122ae4.webp";